<ion-header
  class="ion-no-border"
  [ngClass]="
    platform !== platformEnum.desktop
      ? platform === platformEnum?.tablet
        ? 'ion-header-modal-tablet'
        : 'ion-header-modal-mobile'
      : 'ion-header-modal-desktop'
  "
>
  <ion-toolbar>
    <ion-buttons *ngIf="platform === platformEnum.desktop" slot="end">
      <ion-button
        id="close-modal-btn"
        data-cy="close-recovery-modal-button"
        (click)="dismiss()"
      >
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label
      *ngIf="platform !== platformEnum.desktop"
      class="bold"
      data-cy="recovery-label"
    >
      <span>
        {{ 'i18n.orderSubmittedPage.recoveryModal.recoveryOrderNum' | translate
        }}{{ orderNumber }}
      </span>
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content
  class="recovery-modal-content"
  [ngClass]="
    platform !== platformEnum.desktop
      ? platform === platformEnum?.tablet
        ? 'ion-content-modal-tablet'
        : 'ion-content-modal-mobile'
      : 'ion-content-modal-desktop'
  "
>
  <div
    class="body-content"
    [class.is-touch]="platform !== platformEnum.desktop"
    [class.is-mobile]="platform === platformEnum.mobile"
  >
    <div *ngIf="platform === platformEnum.desktop" class="title">
      <ion-label class="bold" data-cy="recovery-modal-label">
        {{ 'i18n.orderSubmittedPage.recoveryModal.recoveryOrderNum' | translate
        }}{{ orderNumber }}
      </ion-label>
    </div>

    <div class="instructions" [class.touch]="platform !== platformEnum.desktop">
      <span class="bold">{{
        'i18n.orderSubmittedPage.recoveryModal.pleaseNote' | translate
      }}</span
      >{{
        'i18n.orderSubmittedPage.recoveryModal.thisRequestIsValid' | translate
      }}
    </div>

    <div
      class="request-reason-date"
      [class.mobile]="platform === platformEnum.mobile"
    >
      <div class="reason" [ngClass]="showEmail ? 'width-33' : 'width-50'">
        <div class="label bold">
          {{
            'i18n.orderSubmittedPage.recoveryModal.recoveryRequestReason'
              | translate
          }}
          <span class="required-indicator">
            {{ 'i18n.common.requiredInputIndicator' | translate }}
          </span>
        </div>
        <ion-item
          *ngIf="platform === platformEnum.desktop"
          id="click-trigger"
          class="format-button"
          data-cy="select-format-option"
          button
          detail="true"
          detail-icon="chevron-down-outline"
          (click)="openRecoveryPopover($event, recoveryReasonButtons)"
        >
          <span data-cy="select-recovery-reason-value">
            {{ recoveryReason.displayText }}
          </span>
        </ion-item>
        <ion-item
          *ngIf="platform !== platformEnum.desktop"
          id="click-trigger"
          class="format-button"
          data-cy="select-recovery-reason"
          button
          detail="true"
          detail-icon="chevron-down-outline"
          (click)="openActionSheet(recoveryReasonButtons)"
        >
          <span data-cy="select-recovery-reaso-value">
            {{ recoveryReason.displayText }}
          </span>
        </ion-item>
      </div>
      <div class="date" [ngClass]="showEmail ? 'width-33' : 'width-50'">
        <div class="label bold">
          {{
            'i18n.orderSubmittedPage.recoveryModal.requestedDeliveryDate'
              | translate
          }}
          <span class="required-indicator">
            {{ 'i18n.common.requiredInputIndicator' | translate }}
          </span>
        </div>
        <ion-item
          *ngIf="platform === platformEnum.desktop"
          id="click-trigger"
          class="format-button"
          data-cy="select-format-option"
          button
          detail="true"
          detail-icon="chevron-down-outline"
          (click)="openRecoveryPopover($event, dateButtons)"
        >
          <span data-cy="select-format-option-value">
            {{ dateString }}
          </span>
        </ion-item>
        <ion-item
          *ngIf="platform !== platformEnum.desktop"
          id="click-trigger"
          class="format-button"
          data-cy="select-recovery-date"
          button
          detail="true"
          detail-icon="chevron-down-outline"
          (click)="openActionSheet(dateButtons)"
        >
          <span data-cy="select-recovery-date-value">
            {{ dateString }}
          </span>
        </ion-item>
      </div>
      <div
        *ngIf="showEmail"
        class="email"
        [class.mobile]="platform === platformEnum.mobile"
        [ngClass]="showEmail ? 'width-33' : 'width-50'"
      >
        <div class="label bold">
          {{ 'i18n.orderSubmittedPage.recoveryModal.email' | translate }}
          <span class="required-indicator">
            {{ 'i18n.common.requiredInputIndicator' | translate }}
          </span>
          <ion-icon
            (click)="popoverInteraction($event, true)"
            name="information-circle"
            class="email-info-icon"
            data-cy="information-email-address-icon"
          >
          </ion-icon>
        </div>
        <ion-input
          data-cy="email"
          [class]="
            platform === platformEnum.mobile
              ? 'email-input-mobile'
              : 'email-input'
          "
          type="text"
          placeholder="{{
            'i18n.orderSubmittedPage.recoveryModal.exampleEmail' | translate
          }}"
          [(ngModel)]="email"
          (ionInput)="setSubmitButtonReady()"
        ></ion-input>
      </div>
    </div>
    <div class="comments" [class.mobile]="platform === platformEnum.mobile">
      <div class="label">
        {{ 'i18n.common.comments' | translate }}
      </div>
      <ion-input
        data-cy="comments"
        [class]="
          platform === platformEnum.mobile
            ? 'comments-input-mobile'
            : 'comments-input'
        "
        type="text"
        [counter]="true"
        maxlength="500"
        placeholder="{{
          'i18n.orderSubmittedPage.recoveryModal.pleaseProvide' | translate
        }}"
        [(ngModel)]="comments"
      ></ion-input>
    </div>
  </div>
</ion-content>

<ion-footer
  class="ion-footer-modal"
  [class.ion-footer-modal-desktop]="platform !== platformEnum.mobile"
>
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        data-cy="cancel-recovery-modal-button"
        [ngClass]="
          platform !== platformEnum?.mobile
            ? 'usf-outline-green-dsktp-tblt-modal-button'
            : 'usf-outline-green-mobile-modal-button'
        "
        (click)="dismiss()"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>
      <ion-button
        data-cy="submit-recovery-modal-button"
        [ngClass]="
          platform !== platformEnum.mobile
            ? blockSubmission.value
              ? 'usf-fill-disabled-dsktp-tblt-modal-button'
              : 'usf-fill-green-dsktp-tblt-modal-button'
            : blockSubmission.value
              ? 'usf-fill-disabled-mobile-modal-button'
              : 'usf-fill-green-mobile-modal-button'
        "
        (click)="onSubmit()"
      >
        {{ 'i18n.common.submit' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>

<ion-popover
  data-cy="email-info-popover"
  class="email-info-popover"
  [ngClass]="platform === platformEnum?.desktop ? 'desktop' : 'touch'"
  [side]="platform !== platformEnum.desktop ? 'end' : 'top'"
  alignment="center"
  #emailInfoPopover
  mode="ios"
  showBackdrop="false"
  [isOpen]="openPopover"
  (didDissmess)="popoverInteraction(undefined, false)"
>
  <ng-template>
    <app-email-info-popover
      mode="ios"
      [platformType]="platform === platformEnum.desktop ? 'desktop' : 'touch'"
    ></app-email-info-popover>
  </ng-template>
</ion-popover>
